import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { createApiClient } from '@enshield/api-client';
import { SiteShell } from './site/SiteShell';
import { publicApiBaseUrl } from './api-base';

import { HomePage } from './pages/HomePage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { MerchantsPage } from './pages/MerchantsPage';
import { CustomersPage } from './pages/CustomersPage';
import { FaqPage } from './pages/FaqPage';
import { ContactPage } from './pages/ContactPage';
import { ClaimEntryPage } from './pages/ClaimEntryPage';
import { SubmissionRoute, TrackClaimPage } from './pages/ClaimRoutes';
import { PageTransition } from './components/motion';
import { NotFoundPage } from './pages/LegalPages';
import { PublicDocumentsPage } from './pages/PublicDocumentsPage';
import { ClaimsCenterPage } from './pages/ClaimsCenterPage';
import { BookCallPage } from './pages/BookCallPage';

export const PUBLIC_ROUTES = [
  '/', '/platform', '/how-it-works', '/customers', '/for-customers', '/merchants', '/for-merchants',
  '/integrations', '/claims-center', '/book-a-call', '/file-a-claim', '/track-claim', '/faq', '/contact',
  '/end-user-policy', '/privacy-policy', '/terms-of-service', '/learn-more', '/privacy', '/terms',
];

export const publicApiClient = createApiClient({
  baseUrl: publicApiBaseUrl(import.meta.env.VITE_API_BASE_URL),
  credentials: 'omit',
});

export function AppRoutes() {
  /*
   * One incoming fade owns the route handoff. The new route mounts immediately
   * so focus and hash navigation resolve against the content being requested.
   */
  const location = useLocation();
  return (
    <SiteShell>
      <PageTransition pathname={location.pathname} hash={location.hash}>
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/platform" element={<HowItWorksPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />

        {/* Aliases resolve to the same implementation rather than a second
            visual copy of the page. */}
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/for-customers" element={<CustomersPage />} />
        <Route path="/merchants" element={<MerchantsPage />} />
        <Route path="/for-merchants" element={<MerchantsPage />} />

        <Route path="/integrations" element={<HowItWorksPage />} />
        <Route path="/claims-center" element={<ClaimsCenterPage />} />
        <Route path="/book-a-call" element={<BookCallPage />} />
        <Route path="/file-a-claim" element={<ClaimEntryPage apiClient={publicApiClient} />} />
        <Route path="/file-a-claim/:formSlug" element={<SubmissionRoute apiClient={publicApiClient} />} />
        <Route path="/track-claim" element={<TrackClaimPage apiClient={publicApiClient} />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/contact" element={<ContactPage apiClient={publicApiClient} />} />
        <Route path="/end-user-policy" element={<PublicDocumentsPage path="/end-user-policy" />} />
        <Route path="/privacy-policy" element={<PublicDocumentsPage path="/privacy-policy" />} />
        <Route path="/terms-of-service" element={<PublicDocumentsPage path="/terms-of-service" />} />
        <Route path="/learn-more" element={<PublicDocumentsPage path="/learn-more" />} />
        <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/terms" element={<Navigate to="/terms-of-service" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </PageTransition>
    </SiteShell>
  );
}

export default function App() {
  return <BrowserRouter><AppRoutes /></BrowserRouter>;
}
